export const common = {
  save: '儲存',
  cancel: '取消',
  confirm: '確認',
  delete: '刪除',
  edit: '編輯',
  view: '查看',
  create: '建立',
  back: '返回',
  search: '搜尋',
  filter: '篩選',
  export: '匯出',
  import: '匯入',
  refresh: '重新整理',
  loading: '載入中...',
  noData: '暫無資料',
  success: '操作成功',
  error: '操作失敗',
  required: '此欄位為必填',
  optional: '選填',
  all: '全部',
  today: '今天',
  yesterday: '昨天',
  thisWeek: '本週',
  thisMonth: '本月',
  custom: '自定義',
  status: '狀態',
  action: '操作',
  total: '總計',
  submit: '提交',
  reset: '重置',
  close: '關閉',
  open: '開啟',
  enable: '啟用',
  disable: '停用',
  yes: '是',
  no: '否',
  male: '男',
  female: '女',
  phone: '電話',
  email: '電子郵件',
  address: '地址',
  name: '姓名',
  date: '日期',
  time: '時間',
  description: '描述',
  note: '備註',
  settings: '設定',
  logout: '登出',
  profile: '個人資料',
  help: '幫助',
  about: '關於',
  version: '版本',
  language: '語言',
  theme: '主題',
  notification: '通知',
  message: '訊息',
  alert: '提醒',
  warning: '警告',
  info: '資訊',
  download: '下載',
  upload: '上傳',
  copy: '複製',
  paste: '貼上',
  cut: '剪下',
  selectAll: '全選',
  deselectAll: '取消全選',
  more: '更多',
  less: '收起',
  expand: '展開',
  collapse: '收合',
  next: '下一步',
  previous: '上一步',
  finish: '完成',
  skip: '跳過',
  continue: '繼續',
  pause: '暫停',
  resume: '繼續',
  stop: '停止',
  start: '開始',
  retry: '重試',
  undo: '復原',
  redo: '重做',
  clear: '清除',
  apply: '套用',
  preview: '預覽',
  print: '列印',
  share: '分享',
  like: '喜歡',
  favorite: '收藏',
  comment: '評論',
  reply: '回覆',
  forward: '轉發',
  report: '回報',
  block: '封鎖',
  unblock: '解除封鎖',
  follow: '追蹤',
  unfollow: '取消追蹤',
  subscribe: '訂閱',
  unsubscribe: '取消訂閱',
  online: '線上',
  offline: '離線',
  busy: '忙碌',
  away: '離開',
  active: '啟用中',
  inactive: '未啟用',
  pending: '待處理',
  approved: '已核准',
  rejected: '已拒絕',
  completed: '已完成',
  cancelled: '已取消',
  failed: '失敗',
  processing: '處理中',
  waiting: '等待中',
  expired: '已過期',
  draft: '草稿',
  published: '已發布',
  archived: '已封存',
  deleted: '已刪除',
};
